import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { ZodType } from 'zod';

import { SupplierContactForm, SupplierContactFormProps } from '../SupplierContactForm/SupplierContactForm';
import {
  SupplierContactDataOptional,
  supplierContactDataSchema,
} from '../SupplierContactForm/SupplierContactForm.schema';
import { FormChangeDebouncer } from '~/routes/IntakeDetail/components/FormChangeDebouncer/FormChangeDebouncer.tsx';

interface SupplierContactFormRootProps extends SupplierContactFormProps {
  supplier: SupplierContactDataOptional;
  validate?: boolean;
  schema?: ZodType<SupplierContactDataOptional, SupplierContactDataOptional>;
  onChange: (supplier: SupplierContactDataOptional) => void;
}

export const SupplierContactFormRoot = ({
  supplier,
  validate,
  schema = supplierContactDataSchema,
  onChange,
  ...otherProps
}: SupplierContactFormRootProps) => {
  const form = useForm<SupplierContactDataOptional>({
    defaultValues: {},
    resolver: zodResolver(schema),
    mode: 'all',
  });

  useEffect(() => {
    form.reset(supplier);
    if (validate) {
      form.trigger();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FormProvider {...form}>
      <form autoComplete="off" noValidate>
        <FormChangeDebouncer control={form.control} onChange={onChange} />
        <SupplierContactForm {...otherProps} />
      </form>
    </FormProvider>
  );
};
